

/// <reference path="StockNote.ts" />

// Generated class LowOrder_ManagedObject

class LowOrder_ManagedObject extends StockNote
{
}
